import { Table } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { ActivityLog } from "src/services/core/log/models/Log";

type Props = { log: ActivityLog };

const LogRow = ({ log }: Props) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "inApp.logs.activity",
  });

  return (
    <Table.Tr>
      <Table.Td>{log.time.toLocaleTimeString()}</Table.Td>
      <Table.Td>{log.deviceName}</Table.Td>
      <Table.Td>{log.managedUserName}</Table.Td>
      <Table.Td>{t("status." + log.status.toString())}</Table.Td>
      <Table.Td>{t(log.isEnter ? "table.enter" : "table.exit")}</Table.Td>
    </Table.Tr>
  );
};

export default LogRow;
